// extracted by mini-css-extract-plugin
export default {"danceDetail":"DanceStyleDetail_danceDetail__VfwYA","content":"DanceStyleDetail_content__9t57a","backButton":"DanceStyleDetail_backButton__lPM32"};